<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <collapse @getDataList="search" :button-text="'search'">
        <collapse-item>
          <span>水工公司:</span>
          <el-select v-model="queryInfoparams.params.companyId" filterable placeholder="" clearable >
            <el-option  v-for="item in companyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id">
            </el-option>
          </el-select>
        </collapse-item>
        <!-- <collapse-item>
          <span>表单编号</span>
          <el-input placeholder="Please input" v-model.trim="queryInfoparams.params.uniqueCode" clearable></el-input>
        </collapse-item> -->
      </collapse>
      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button plain size="small"  icon="el-icon-plus" @click="addDialogVisible=true" >新增表单</el-button>
            <el-button plain size="small"  icon="el-icon-delete" @click="deleteClick" >删除</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-table :data="dataList" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="水工公司" prop="companyName"></el-table-column>
        <el-table-column label="创建时间" sortable prop="createdTime"></el-table-column>
        <el-table-column label="链接二维码" prop="qrCode">
          <template slot-scope="scope">
            <img src="../../assets/img/bg-qrCode.png" alt="" @click="previewImage(scope.row)" class="item-img" />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="btnContainer">
              <el-link @click="showDetail(scope.row)">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfoparams.current"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="queryInfoparams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
    </el-card>
    <!-- 表单二维码查看 -->
    <el-dialog
      title="表单二维码查看"
      :visible.sync="dialogVisible"
      width="20%"
      >
      <img width="100%" :src="previewObj.url"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadImg">下载本地</el-button>
      </span>
    </el-dialog>
    <!-- 新增表单-->
    <el-dialog
      title="新增表单"
      :visible.sync="addDialogVisible"
      width="50%"
      @close="addDialogVisible=false"
    >
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
        <el-form-item label="选择所属水工公司:" label-width="180px" prop="companyId">
          <el-select v-model="addForm.companyId" filterable placeholder="" clearable >
            <el-option  v-for="item in companyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitForm">Save</el-button>
      </span>
    </el-dialog>

    <!-- 表单详情-->
    <el-dialog
      title="表单详情"
      :visible.sync="showDialogVisible"
      width="50%"
      @close="showDialogVisible=false"
    >
      <el-form :model="showItem" :rules="addFormRules" ref="addFormRef" label-width="100px">
        <el-form-item label="选择所属水工公司:" label-width="180px" prop="companyId" disabled>
          <el-select v-model="showItem.companyId" filterable placeholder="" disabled >
            <el-option  v-for="item in companyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id">
            </el-option>
          </el-select>


        </el-form-item>
        <el-form-item label="链接二维码:" label-width="180px" prop="url" disabled>
          <el-image
             class="img"
             :src="showItem.url"
             :preview-src-list="[showItem.url]">
           </el-image>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogVisible = false">close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
import { Loading } from 'element-ui';
  export default {
    components:{Collapse,CollapseItem},
    data() {
      return {
        companyList: [],
        addForm: {
          companyId: ''
        },
        addFormRules: {
          companyId: [
            { required: true, message: '请选择所属水工公司', trigger: 'change' }
          ]
        },
        queryInfoparams: {
          current: 0,
          params: {},
          size: 10,
        },
        dialogVisible: false,
        addDialogVisible: false,
        total: 0,
        dataList: [], // 列表显示
        previewObj: {}, // 预览的表单
        multipleSelection: [], //选择列表
        url: '', //识别二维码的内容

        showDialogVisible: false,
        showItem:{
          url: ""
        }
      }
    },

    created(){
      this.getCompanyList()
      this.search()
      const baseUrl = this.$getBaseUrl()
      this.url = baseUrl.slice(0,-3)+'order/#/OrderRecord/'
    },

    methods: {
      //获取所有的水工公司
      getCompanyList() {
        this.$post('engineerCompany/queryEngineerCompanys', this.queryInfoparams).then(
          ({ data: res }) => {
            this.companyList = res
          }
        )
      },

      // 删除表单
      deleteClick() {
        if (this.multipleSelection && this.multipleSelection.length >0) {
          this.$confirm('是否确认删除您所选中的所有表单！！！', '温馨提示', {
            confirmButtonText: 'Sure',
            cancelButtonText: 'Cancel',
            customClass: 'submit-box'
          }).then(()=> {
            const ids = this.multipleSelection.map(obj => {
              return obj.id
            }).join(',')
            const that = this
            that.$get(`engineerOrderTemplate/deleteOption/${ids}`).then(
              ({ data: res }) => {
                if (res.code == 200) {
                  that.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  that.search()
                } else {
                  that.$message.error(res.msg);
                }
              }
            )
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }else {
          this.$message('请先选择要删除的表单');
          return
        }
      },

      // 新增表单
      submitForm() {
        this.$refs.addFormRef.validate(async (valid) => {
          if (valid) {
            this.$post('engineerOrderTemplate/add', this.addForm).then(
              ({ data: res }) => {
                if (res.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '新增成功!'
                  });
                  this.addDialogVisible = false
                  this.addForm.companyId =''
                  this.$refs.addFormRef.resetFields();
                  this.search()
                } else {
                  this.$message.error(res.msg);
                }
              }
            )
          }
        })
      },

      async showDetail(item){
        this.showDialogVisible = true
        this.showItem = {...item, url: ""};
        let src = this.url+item.id
        await this.$post('engineerOrderTemplate/qrCode/',{text: src}).then(
          ({ data: res }) => {
            if (res.code == 200) {
              this.showItem.url = res.data
            } else {
              this.$message.error(res.msg);
            }
          }
        )

      },
      // 预览图片
     previewImage(data) {
        this.previewObj.company = data.companyName
        let src = this.url+data.id
        this.$post('engineerOrderTemplate/qrCode/',{text: src}).then(
          ({ data: res }) => {
            if (res.code == 200) {
              this.dialogVisible = true
              this.previewObj.url = res.data
            } else {
              this.$message.error(res.msg);
            }
          }
        )
      },

      // 下载二维码
      downloadImg() {
        let loadingInstance = Loading.service({
          text: 'Loading',
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        fetch(this.previewObj.url).then(res => res.blob()).then(blob => {
          var link = document.createElement('a')
          link.style.display = 'none'
          document.body.appendChild(link)
          var url = window.URL.createObjectURL(blob)
          link.href = url
          link.download = this.previewObj.company
          link.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
          setTimeout(()=> {
            this.dialogVisible = false
            loadingInstance.close();
            this.previewObj = {}
          },500)
        })
      },

      //监控checkbox的选择,为entity的所有值
      handleSelectionChange (val) {
        this.multipleSelection = val
      },

      // 查询
      search () {
        this.queryInfoparams.current = 0
        this.getDataList()
      },

      // 获取 查询数据列表
      async getDataList() {
        this.$post('engineerOrderTemplate/pageQuery', this.queryInfoparams).then(
          ({ data: res }) => {
            this.dataList = res.records
            this.total = res.total
          }
        )
      },

      // 监听pagesize改变的事件
      handleSizeChange(newSize) {
        this.queryInfoparams.size = newSize
        this.getDataList()
      },

      // 监听页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfoparams.current = newPage
        this.getDataList()
      }
   }
  }

</script>

<style lang="less">
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.collapseBtn {
  height: 40px;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

#el-collapse-head-4510{
  height: auto;
}
.el-col{
  display: flex;
}
.el-date-editor{
   height: auto;
   width:auto;
}
.demonstration1{
  height: auto;
  width:25%;
}
.el-button{
     height: auto;
     width:auto;
}
.left{
  width:auto;
}
#el-input__inner{
  width:200px;
}
.item-img {
  width: 40px !important;
  height: 40px !important;
}
.el-form {
  width: 70%;
}
.el-dialog__footer{
  text-align: center;
}
.submit-box .el-message-box__title,
.submit-box .el-message-box__message {
  color: red;
}
.submit-box .el-message-box__btns,
.submit-box .el-message-box__message {
  text-align: center;
}
</style>
